import {FieldGroupConfig} from "../../../../../models/filter/filter.group";
import {FieldTypeName} from "../../../../../models/filter/filter.field.type.name";
import {ClaimStatus, ClaimType} from "../../../../../models/claims/claims";
import {Translate} from "../../../../../hooks/translate.hook";

export const filterGroupsFactory = (t: Translate): FieldGroupConfig[] => {
    return [
        {
            visibleName: 'TYPE',
            name: 'type',
            fields: [
                {
                    name: 'type',
                    type: FieldTypeName.SELECT,
                    choices: Object.values(ClaimType).map(value => {
                        return {
                            name: t('CLAIMS.CLAIM.TYPE.' + value.toUpperCase()),
                            value: value
                        }
                    }),
                    multiple: true
                }
            ],
        },
        {
            visibleName: 'STATUS',
            name: 'statuses',
            fields: [
                {
                    name: 'statuses',
                    type: FieldTypeName.SELECT,
                    choices: Object.values(ClaimStatus).map(value => {
                        return {
                            name: t('CLAIMS.CLAIM.STATUS.' + value.toUpperCase()),
                            value: value
                        }
                    }),
                    multiple: true
                }
            ],
        },
        {
            visibleName: 'DOCUMENT_NUMBER',
            name: 'documentNumber',
            fields: [
                {
                    name: 'documentNumber',
                    type: FieldTypeName.STRING
                }
            ]
        },
        {
            visibleName: 'TOTAL_PRICE',
            name: 'subtotal',
            fields: [
                {
                    name: 'subtotal',
                    type: FieldTypeName.INTEGER
                }
            ]
        },
        {
            visibleName: 'CREATED_AT',
            name: 'createdAt',
            fields: [
                {
                    name: 'createdAt',
                    type: FieldTypeName.DATE_RANGE
                }
            ]
        }
    ];
}